const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import LanguageManager from "../../../../manager/language_manager";

@ccclass
export default class MatchWaitStartView extends ViewBase {

    @property(cc.Label)
    label_content: cc.Label = null

    protected m_timeout_id: number = 0

    showPanel(show: boolean, state?: number, leftSecs?: number){
        this.node.active = !!show
        if(show){
            switch (state) {
                case 1:
                    this.showWaitOtherPanel()
                    break;
                case 2: 
                    this.showWaitResultEndPanel()
                    break;
                case 3:
                    this.showWaitStartPanel(leftSecs)
                    break;
                case 4:
                    this.showWaitForReady()
                    break;
                default:
                    break;
            }            
        }
    }

    showWaitStartPanel(leftSecs: number) {
        if(this.m_timeout_id){
            let id = this.m_timeout_id
            this.m_timeout_id = 0
            this.cancelSchedule(id)
        }
        this.label_content.string = LanguageManager.t("table_wait_secs_for_start", true).format(leftSecs);
        if(leftSecs > 0){
             this.m_timeout_id = this.doScheduleOnce(()=>{
                leftSecs--
                this.showWaitStartPanel(leftSecs)
            }, 1)
        }        
    }

    showWaitOtherPanel(){
        if(this.m_timeout_id){
            let id = this.m_timeout_id
            this.m_timeout_id = 0
            this.cancelSchedule(id)
        }
        this.label_content.string = LanguageManager.t("table_wait_others_in", true)
    }

    showWaitResultEndPanel(){
        if(this.m_timeout_id){
            let id = this.m_timeout_id
            this.m_timeout_id = 0
            this.cancelSchedule(id)
        }
        this.label_content.string = LanguageManager.t("table_wait_result_end", true)
    }

    showWaitForReady(){
        if(this.m_timeout_id){
            let id = this.m_timeout_id
            this.m_timeout_id = 0
            this.cancelSchedule(id)
        }
        this.label_content.string = LanguageManager.t("table_wait_other_ready", true)
    }
}